module.exports = __webpack_public_path__ + "static/biographie-7a8cd8179440656c3792fa876d139d86.jpg";